var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"tipo-solicitacao-matricula","rota-base":"/admin/tipo-solicitacao-matricula","titulo":"TIPOS DE SOLICITAÇÃO DE MATRÍCULA","titulo-singular":"Tipo de Solicitação de Matrícula","colunas-extras":[]}})
}
var staticRenderFns = []

export { render, staticRenderFns }